import React, { FC, useContext } from 'react'
import { ShareIcon, CheckIcon, ChevronLeftIcon } from '@heroicons/react/outline'
import { Link } from 'react-router-dom'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'
import { userStore } from '../../../utils/UserContext'
import { Button } from '../../../System'
import { useCopyToClipboard } from '../../../utils/copyToClipboard'
import { StyledWorks } from '.'
import ROUTES from '../../../utils/routes'
import { AppState } from '../../../../redux/root-reducer'
import { ChallengeState } from '../../../../redux/challenge/types'

const Challenge: FC = () => {
  const { user } = useContext(userStore)
  const {
    isCopied,
    actions: { copyToClipboard }
  } = useCopyToClipboard()
  const { origin } = window.location
  const affiliateUrl = `${origin}/a/${user?.id}?plan=Challenge`
  const { currentChallenge } = useSelector<AppState, ChallengeState>((state) => state.challenge)

  return (
    <StyledWorks>
      <div className="top-content">
        <Link to={ROUTES.affiliates.links}>
          <Button theme="outline" className="back-btn" isIcon>
            <ChevronLeftIcon />
          </Button>
        </Link>
        <div className="share-link-input-container">
          <span className="share-link-input-label">Share Link</span>
          <div className="share-link-input">
            <span>{affiliateUrl}</span>
            <Button
              iconPos="right"
              className="copy-link-btn"
              isDisabled={isCopied}
              onClick={() => copyToClipboard(affiliateUrl)}
            >
              {isCopied ? (
                <>
                  COPIED <CheckIcon />
                </>
              ) : (
                <>
                  COPY LINK <ShareIcon />
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
      <div className="heading">
        <h2>Social Curator Subscription Payout Details</h2>
        <p>
          Every time someone signs up to participate in the challenge using your link and then
          upgrades to a paid subscription within 14 days, you'll both receive benefits.
          Registrations for the challenge are open from{' '}
          {moment(currentChallenge?.start)
            .tz('America/Los_Angeles')
            .format('MMMM D, YYYY [at] hA zz')}{' '}
          through{' '}
          {moment(currentChallenge?.joinBy)
            .tz('America/Los_Angeles')
            .format('MMMM D, YYYY [at] hA zz')}
          .
        </p>
      </div>
      <div className="payout-details">
        <h3>
          <b>You</b> receive a one-time payment of:
        </h3>
        <div className="payout-detail-grid">
          <div className="payout-detail">
            <div className="work-step-number">
              <span>1</span>
            </div>
            <b>$49</b>
            <span>per new monthly subscription</span>
          </div>
          <div className="payout-detail">
            <div className="work-step-number">
              <span>2</span>
            </div>
            <b>$75</b>
            <span>per new annual subscription</span>
          </div>
        </div>
      </div>
      <div className="payout-details">
        <h3>
          <b>They</b> receive a discount of:
        </h3>
        <div className="payout-detail-grid">
          <div className="payout-detail">
            <div className="work-step-number">
              <span>1</span>
            </div>
            <b>$24 off</b>
            <span>their first month</span>
          </div>
          <div className="payout-detail">
            <div className="work-step-number">
              <span>2</span>
            </div>
            <b>$100 off</b>
            <span>their first year</span>
          </div>
        </div>
      </div>
    </StyledWorks>
  )
}

export default Challenge
